import { render, staticRenderFns } from "./DeveloperGamesTemp.vue?vue&type=template&id=6a0a1234&scoped=true"
import script from "./DeveloperGamesTemp.vue?vue&type=script&lang=js"
export * from "./DeveloperGamesTemp.vue?vue&type=script&lang=js"
import style0 from "./DeveloperGamesTemp.vue?vue&type=style&index=0&id=6a0a1234&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0a1234",
  null
  
)

export default component.exports